import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OsteotomyWorkflowComponent } from '../correction';
import { BoneTypeSelectionComponent, MechanicalAxisComponent } from '../deformity';
import { CroppingWorkflowComponent, RotationWorkflowComponent } from '../image-setup';
import { TemplateSelectionComponent } from '../product';
import { BaseComponent } from '../shared';
import { DrawerComponent } from './drawer';
import { ToolsMenuComponent } from './tools-menu';


/**
 * First left vertical bar.
 */
@Component({
	selector: 'sidebar',
	templateUrl: './sidebar.component.html',
	imports: [
		DrawerComponent,
		ToolsMenuComponent,
		MechanicalAxisComponent,
		RotationWorkflowComponent,
		CroppingWorkflowComponent,
		OsteotomyWorkflowComponent,
		TemplateSelectionComponent,
		BoneTypeSelectionComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class SidebarComponent extends BaseComponent { }
